<div class="hjelp-dialog-innhold">
  <h2 mat-dialog-title id="hjelp-dialog-tittel" class="tittel">
    {{ 'Hva kan vi hjelpe deg med?' | translate }}
  </h2>

  <mat-dialog-content>
    <div class="hoveddel">
      <p class="ingress">
        {{ 'Finn svar og steg-for-steg-veiledninger i Hjelpesenteret' | translate }}
      </p>

      <div class="handling-rad">
        <a mat-raised-button color="primary" [href]="hjelpesenterUrl" target="_blank" rel="noopener noreferrer">
          {{ 'Åpne Hjelpesenteret' | translate }}
        </a>
      </div>
    </div>

    <mat-divider class="skillelinje"></mat-divider>

    <div class="kontakt-seksjon">
      <p class="kontakt-tittel">
        {{ 'Finner du ikke svaret?' | translate }}
      </p>
      <div class="kontakt-linje">
        <a class="kontakt-lenke" [href]="'mailto:' + epost">{{ epost }}</a>
        <span class="prikk">•</span>
        <a class="kontakt-lenke" [href]="telefonLenke">{{ telefon }}</a>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="lukk-knapp">
      {{ 'LUKK' | translate }}
    </button>
  </mat-dialog-actions>
</div>
